import BrowserPluginRoute, { BrowserPluginRouteProps } from './BrowserPluginRoute';

export type EmbedPluginRouteProps = Omit<BrowserPluginRouteProps, 'useAtsEventStrategy'>
  & Partial<Pick<BrowserPluginRouteProps, 'useAtsEventStrategy'>>

const EmbedPluginRoute = (props: EmbedPluginRouteProps) => BrowserPluginRoute({
  ...props,
  useAtsEventStrategy: props.useAtsEventStrategy ?? true,
  authHeaderType: props.authHeaderType ?? 'Bearer',
});

export default EmbedPluginRoute